// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-14.use[1]!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-14.use[2]!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-14.use[3]!../../node_modules/windicss-webpack-plugin/dist/loaders/windicss-template.js!../../node_modules/windicss-webpack-plugin/dist/loaders/windicss-css.js!./element.css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("70b70672", content, true, {"sourceMap":false,"shadowMode":false});